import React from 'react';
import clsx from 'clsx';
import styles from './ProductBadges.module.scss';

const ProductBadges = ({ badges, className }) => {
  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <div className={clsx(styles.root, className)}>
      {badges.map(badge => (
        <img key={badge.id} className={styles.image} src={badge.image} alt={badge.name} />
      ))}
    </div>
  );
};

export default ProductBadges;
